export enum AvailableStatus {
  Active = 'Active',
  Expired = 'Expired',
  Inactive = 'Inactive',
  New = 'New',
}
